// Currency configuration sourced from src/config/countries/<code>.json
// via the per-country loader. Selection is driven by REACT_APP_PORTAL_COUNTRY
// at build time.

import country from 'config/countryConfig';

export const CURRENCY_CODE: string = country.currencyCode;
export const CURRENCY_SYMBOL: string = country.currencySymbol;
